/*------------------------------------*\
    BABEL POLYFILL
\*------------------------------------*/
import "babel-polyfill";

/*------------------------------------*\
    MODULES
\*------------------------------------*/
import TypeMate from 'typemate';
import Bootstrap from 'bootstrap';

import Calendar from './modules/calendar';
import DataTable from './modules/data-table';
import HeroInfo from './modules/hero-info';
import MapStuds from './modules/map-studs';
import Map from './modules/map';
import Nav from './modules/nav';
import RaceCalendar from './modules/race-calendar';
import RacingCalendar from './modules/racing-calendar';
import StopVideos from './modules/stop-videos';
import Tabs from './modules/tabs';
import VideoModal from './modules/video-modal';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if(!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if(!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch(module) {

                    case 'nav':

                        let navInstance = new Nav(item);

                        navInstance.init();

                        break;

                    case 'video-modal':

                        let videoModalInstance = new VideoModal(item);

                        videoModalInstance.init();

                        break;

                    case 'data-table':

                        let dataTableInstance = new DataTable(item);

                        dataTableInstance.init();

                        break;

                    case 'map':

                        let mapInstance = new Map(item);

                        mapInstance.init();

                        break;

                    case 'map-studs':

                        let mapStudsInstance = new MapStuds(item);

                        mapStudsInstance.init();

                        break;

                    case 'tabs':

                        let tabsInstance = new Tabs(item);

                        tabsInstance.init();

                        break;

                    case 'calendar':

                        let calendarInstance = new Calendar(item);

                        calendarInstance.init();

                        break;

                    case 'race-calendar':

                        let raceCalendarInstance = new RaceCalendar(item);

                        raceCalendarInstance.init();

                        break;

                    case 'racing-calendar':

                        let racingCalendarInstance = new RacingCalendar(item);

                        racingCalendarInstance.init();

                        break;

                    case 'hero-info':

                        let heroInfoInstance = new HeroInfo(item);

                        heroInfoInstance.init();

                        break;

                    case 'stop-videos':

                        let stopVideosInstance = new StopVideos(item);

                        stopVideosInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        const typeMateInstance = new TypeMate(document, {
            ignoreClass: 'typemate-ignore'
        });
        typeMateInstance.apply();
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    }
};

// Launch
app.init();
